import "../scss/main.scss";

import "./header-bar";
import "./notification-bar";
import "./contact-form";
import "./owl-carousel";
import "./property";
import "./job-details";
import "./scrolltop";
import "./re-captcha";
